import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AddEditIntegrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AddEditIntegrationModalContainer" */
      './AddEditIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
